import { render, staticRenderFns } from "./label.vue?vue&type=template&id=214a7b02&scoped=true&"
import script from "./label.vue?vue&type=script&lang=js&"
export * from "./label.vue?vue&type=script&lang=js&"
import style0 from "./label.vue?vue&type=style&index=0&id=214a7b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214a7b02",
  null
  
)

export default component.exports